module.exports = __webpack_public_path__ + "img/home.401cfda7.jpg";